import { jsx } from 'panel';
import { MarkdownEl } from 'common/components/markdown';
import { DisplaySize } from './types';
export function template() {
  const {
    visibility
  } = this.state;
  const imageUrl = this.attr("image-src");
  const text = this.attr("text");
  return jsx("div", {
    sel: '.mp-tooltip',
    class: {
      'has-max-width': this.attr("max-width") !== null || this.attr("size") !== DisplaySize.Fit,
      'is-animated': this.helpers.shouldAnimateTooltip(),
      'has-image': !!imageUrl,
      ["is-".concat(visibility)]: true,
      ["size-".concat(this.attr("size"))]: true
    },
    style: this.attr("max-width") && {
      'max-width': this.attr("max-width"),
      hyphens: "auto"
    },
    on: {
      click: this.helpers.stopPropagation,
      mousedown: this.helpers.stopPropagation
    }
  }, imageUrl && jsx("img", {
    sel: '.mp-tooltip-image',
    attrs: {
      src: imageUrl
    }
  }), jsx("slot", null), text && jsx(MarkdownEl, {
    sel: '.mp-tooltip-text',
    attrs: {
      text
    }
  }), jsx("div", {
    sel: '.mp-tooltip-arrow'
  }));
}